"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrittenBackIndicator = exports.WRITTEN_BACK_SHORT_LABEL = exports.WRITTEN_BACK_LABEL = void 0;
var _react = _interopRequireDefault(require("react"));
var _lucideReact = require("lucide-react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var WRITTEN_BACK_LABEL = exports.WRITTEN_BACK_LABEL = "Written back as a new paragraph";
var WRITTEN_BACK_SHORT_LABEL = exports.WRITTEN_BACK_SHORT_LABEL = "Written back";
var WrittenBackIndicator = exports.WrittenBackIndicator = function WrittenBackIndicator(_ref) {
  var writtenBackReason = _ref.writtenBackReason;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: "flex items-center gap-1 text-[11px] font-medium text-[#166534]",
    role: "status",
    title: writtenBackReason,
    "data-sentry-component": "WrittenBackIndicator",
    "data-sentry-source-file": "WrittenBackIndicator.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.CornerDownLeft, {
      size: 13,
      className: "flex-shrink-0",
      "aria-hidden": "true",
      "data-sentry-element": "CornerDownLeft",
      "data-sentry-source-file": "WrittenBackIndicator.tsx"
    }), WRITTEN_BACK_LABEL]
  });
};